import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { GetPlansResponse } from "@syla/shared/types/responses/GetPlansResponse";
import axios from "axios";

export async function getPlans(): Promise<GetPlansResponse> {
  const response = await axios.get<TransportType<GetPlansResponse>>("/plans/");
  return response.data;
}
